import http, { IObjNum, IObjStr, IObjStrNum, IObjStrNumObj, IObjStrObj } from '@/utils/http';
import { storage } from '@/utils/storage';
import { isWeixin } from '@/utils/common';
const prefix = '/ysr-h5-app';
/** 微信/支付宝内只请求支持微信端展示的产品，非微信不传该字段以保持原匹配逻辑 */
const withWechatDisplayParams = (data?: IObjStrNum): IObjStrNum | undefined => {
  if (!isWeixin()) {
    return data;
  }
  return {
    ...(data || {}),
    wechatDisplaySupported: 1,
  };
};
/**
 * 获取验证码
 * **/
export const getSmsCode = (params: IObjStr): Promise<IObjStr> =>
  http.post<IObjStr>(`${prefix}/web/user/sendSms`, params);
export const getSmsCodeCheck = (params: IObjStr): Promise<IObjStr> =>
  http.post<IObjStr>(`${prefix}/web/user/login/delay/check`, params);
/**
 * 验证码登录,注册
 * */
export const codeRegister = (data: IObjStr): Promise<IObjStr> =>
  http.post<IObjStr>(`${prefix}/web/user/login`, data);
/**个推登录*/
export const oneClickLogin = (data: IObjStr): Promise<IObjStr> =>
  http.post<IObjStr>(`${prefix}/web/user/oneClickLogin`, data);

/**h5访问*/
export const h5Visit = (): Promise<void> => http.post<void>(`${prefix}/web/buried/h5Visit`);

/**根据ip获取当前城市*/
export const ipAddr = (): Promise<IObjStr> => http.post<IObjStr>(`${prefix}/web/common/ipAnalysis`);

/**获取用户基本信息*/
export const baseUserInfo = (): Promise<IObjStr> =>
  http.post<IObjStr>(`${prefix}/web/user/baseUserInfo`);
/**获取渠道*/
export const getChannelFlagCode = (params: IObjStr): Promise<IObjStr> => {
  return http.post<IObjStr>(prefix + '/web/channel/channelFlagCode', params);
};
/**保存用户贷款金额*/
export const saveUserLoanMoney = (params: IObjNum): Promise<IObjStr> => {
  const regMoney = /^[+-]?(0|([1-9]\d*))(\.\d+)?$/;
  if (!regMoney.test(String(params.loanMoney))) {
    params.loanMoney = 2;
    storage.setItem('loanInfo', params, null, 2);
  }
  return http.post<IObjStr>(prefix + '/web/h5/capital/saveUserLoanMoney', params);
};
/**用户是否需要留资**/
export const ifUserCapital = (): Promise<IObjStr> => {
  return http.post<IObjStr>(prefix + '/web/h5/capital/ifUserCapital');
};
/**根据渠道ID查看渠道详情*/
export const getChannelDetail = (data: IObjStr): Promise<IObjStrNumObj> =>
  http.post<IObjStrNumObj>(prefix + '/web/channel/detail', data);
/**获取用户信息**/
export const getUserInfo = () => http.post('/web/user/baseUserInfo');
/**钱包是否存在产品**/
export const recommendBankPro = (): Promise<IObjStrNumObj> =>
  http.post<IObjStrNumObj>(prefix + '/web/h5/interaction/recommendBankPro');
/**钱包联登**/
export const unionLoginWallet = (): Promise<IObjStrNumObj> =>
  http.post<IObjStrNumObj>(prefix + '/web/h5/interaction/unionLoginWallet');
/**埋点**/
export const buriedCapital = (data: IObjStr): Promise<IObjStr> =>
  http.post<IObjStr>(prefix + '/web/page/buried/capital', data);
/**渠道埋点**/
export const pointTrigger = (data: IObjStr): Promise<IObjStr> =>
  http.post<IObjStr>(prefix + '/web/channel/point/trigger', data);
/* 查询协议合规 */
export const getAgreement = (data: IObjStr): Promise<IObjStr> =>
  http.post<IObjStr>(prefix + '/web/user/agreement/platform', data);
export const getAgreementH5 = (data: IObjStr): Promise<IObjStr> =>
  http.post<IObjStr>(prefix + '/web/user/h5/agreement/platform', data);
/* 协议存证-埋点 */
export const contractSign = (data: IObjStr): Promise<IObjStr> =>
  http.post<IObjStr>(prefix + '/web/contract/sign', data);
/* 20230428 - 全流程埋点 - 登录 */
export const operateBuried = (data: IObjStr): Promise<IObjStr> =>
  http.post<IObjStr>(prefix + '/web/buried/user/operation', data);
/* 20230428 - 全流程埋点 - 未登录 */
export const operateBuriedNoToken = (data: IObjStr): Promise<IObjStr> =>
  http.post<IObjStr>(prefix + '/web/buried/user/visit', data);

/**20230605 获取钱包的跳转域名*/
export const getWalletDomain = (): Promise<IObjStr> =>
  http.post<IObjStr>(prefix + '/web/domain/getWalletDomain');

/**访问流程准入*/
export const accessProcess = (): Promise<IObjStr> =>
  http.get<IObjStr>(prefix + '/web/channel/accessProcess');

/**查询渠道页面配置信息**/
export const channelPageConfigDetail = (data: IObjStr): Promise<IObjStr> =>
  http.post<IObjStr>(prefix + '/web/channel/channel-page-config/detail', data);

/**可以申请网贷产品数量*/
export const canApplyLoanNum = (): Promise<number> =>
  http.get<number>(prefix + '/web/product/canApplyLoanNum');

/**推荐网贷 h5 类别*/
export const recommendLoanProH5 = (data?: IObjStrNum): Promise<IObjStr[]> => {
  const params = withWechatDisplayParams(data);
  if (params) {
    return http.post<IObjStr[]>(prefix + '/web/h5/interaction/recommendLoanProH5', params);
  }
  return http.post<IObjStr[]>(prefix + '/web/h5/interaction/recommendLoanProH5');
};

/**推荐网贷 h5 类别*/
export const applyOnlineLendingLoan = (data: IObjStr): Promise<IObjStr> =>
  http.post<IObjStr>(prefix + '/web/h5/interaction/applyOnlineLendingLoan', data);

/**商超独立产品列表*/
export const queryScProductList = (): Promise<IObjStr[]> =>
  http.post<IObjStr[]>(prefix + '/web/h5/interaction/queryScProductList');

/**商超独立产品申请*/
export const applyScProduct = (data: IObjStrObj): Promise<IObjStr> =>
  http.post<IObjStr>(prefix + '/web/h5/interaction/applyScProduct', data);

export const reportScChannelDataPoint = (data: IObjStrObj): Promise<IObjStr> =>
  http.post<IObjStr>(prefix + '/web/h5/interaction/reportScChannelDataPoint', data);

/**渠道落地页IP归因记录*/
export const channelPageIpRecord = (): Promise<IObjStr> =>
  http.get<IObjStr>(prefix + '/web/channel/channelPageIpRecord');

/**广点通api -- 腾讯 | 快手*/
export const infoFlowConversion = (data: IObjStrNum): Promise<IObjStr> =>
  http.post<IObjStr>(prefix + '/web/infoFlow/conversion', data);

/**根据显示位置获取弹窗配置信息   49、H5补充留资页   50、访问页   51、留资页   52、结果页   53、guide  66、黑名单   */
export const getPopWindowByLocation = (data: IObjStrNum): Promise<IObjStr> =>
  http.post<IObjStr>(prefix + '/web/creditConversionControl/getPopWindowByLocation', data);
export const getPopWindowListByLocation = (data: IObjStrNum): Promise<IObjStr[]> =>
  http.post<IObjStr[]>(prefix + '/web/creditConversionControl/getPopWindowListByLocation', data);
/**落地页普通网贷产品匹配*/
export const onlineLoanProductMatch = (data?: IObjStrNum): Promise<IObjStrObj[]> => {
  const params = withWechatDisplayParams(data);
  if (params) {
    return http.post<IObjStrObj[]>(
      prefix + '/web/creditConversionControl/onlineLoanProductMatch',
      params
    );
  }
  return http.post<IObjStrObj[]>(prefix + '/web/creditConversionControl/onlineLoanProductMatch');
};
/**申请普通网贷*/
export const applyOnlineLoan = (data: IObjStrNum): Promise<IObjStr> =>
  http.post<IObjStr>(prefix + '/web/creditConversionControl/applyOnlineLoan', data);
/**获取落地页推荐产品相关协议 网贷*/
export const getProtocolOnline = (data: IObjStrNum): Promise<IObjStrObj> =>
  http.post<IObjStrObj>(prefix + '/web/h5ProtocolControl/getProtocol', data);
/**补充三要素认证 用户信贷留资完成 在过渡页面 信贷产品匹配接口有产品返回时 调用此接口*/
export const authForThree = (): Promise<IObjStrObj> =>
  http.post<IObjStrObj>(prefix + '/web/h5/capital/authForThree');

/** 回传渠道 ？后所有参数 */
export const updateChannelUrlParams = (data: IObjStrNum): Promise<IObjStr> =>
  http.post<IObjStr>(prefix + '/web/channel/channelDataRetrievalControl/attributeReport', data);
/**公众号数据显示埋点*/
export const clickCount = (data: IObjStrNum): Promise<IObjStr> =>
  http.post<IObjStr>(prefix + '/web/official/click/count', data);

/** 上报clickId */
export const clickConversionUpClickId = (data: IObjStr): Promise<IObjStr> =>
  http.post<IObjStr>(prefix + '/web/h5/clickConversion/upClickId', data);

export const officialAccountDownloadPageSend = (): Promise<void> =>
  http.post<void>(prefix + '/web/messageSendControl/officialAccountDownloadPageSend');

/** 一拦弹窗-直接地址跳转 上报 */
export const backReportDirectAdUrl = (data: IObjStrNum): Promise<IObjStr> =>
  http.post<IObjStr>(prefix + '/web/creditConversionControl/reportDirectAdUrl', data);
export const getWeChatLink = (data: IObjStrNum): Promise<IObjStr> =>
  http.post<IObjStr>(prefix + '/web/user/getWeChatLink', data);
export const getWeChatCode = (data: IObjStr): Promise<IObjStr> =>
  http.post<IObjStr>(prefix + '/web/user/getWeChatCode', data);

export const reportUserChanel = (data: string): Promise<IObjStr> =>
  http.post<IObjStr>(prefix + '/web/channel/reportUserChanel/' + data);

/** 动态一拦-根据位置获取--普通网贷数据 */
export const getOnlineLoanWindowByLocation = (data: IObjStrNum): Promise<IObjStrObj> =>
  http.post<IObjStr>(prefix + '/web/creditConversionControl/getOnlineLoanWindowByLocation', data);

/**H5下载页短信召回*/
export const smsRecall = () => http.post(prefix + '/web/messageSendControl/h5/downloadPage/recall');
export const smsRecall101 = () =>
  http.post(prefix + '/web/messageSendControl/h5/downloadPage/recall/101');

export const h5OnlineLoanProductRecommend = () =>
  http.post(prefix + '/web/creditConversionControl/h5OnlineLoanProductRecommend');


export const sendUpSpeedMsg = () =>
  http.post<void>(prefix + '/web/messageSendControl/h5/downloadPage/sendUpSpeedMsg');

/** 获取水滴保险投保 H5 地址（无业务参数，不传 body） */
export const getInsuranceProductUrl = (): Promise<{ productUrl?: string }> =>
  http.post<{ productUrl?: string }>(prefix + '/web/h5/insurance/product-url');
